"use client";

import { Button, Title, Select, Textarea } from "rizzui";
import { ChangeEvent, useCallback, useState } from "react";
import { cn } from "@/lib/utils";
import { isEmpty } from "lodash";
import { EActionMethod, IItemPayment } from "@/utilities/types/Payment";

export type Reason = {
  label: string;
  value: string;
};

const reasonOptions: Reason[] = [
  {
    label: "Irrelevant screenshot",
    value: "irrelevant_screenshot",
  },
  {
    label: "Paid to incorrect recipient",
    value: "paid_to_incorrect_recipient",
  },
  {
    label: "Incorrect payment amount",
    value: "incorrect_payment_amount",
  },
];

interface IPropSelectReason {
  changeStatusPayment: (
    id: string,
    type: string,
    reason: string
  ) => Promise<void>;
  item: IItemPayment;
  closeModal: () => void;
}

export default function SelectReason(props: IPropSelectReason) {
  const { changeStatusPayment, item, closeModal } = props;
  const [reasonValue, setReasonValue] = useState<string>("");
  const [otherReasonValue, setOtherReasonValue] = useState<string>("");

  const onChangeOther = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    setOtherReasonValue(value);
  };

  const onSubmitReject = useCallback(() => {
    closeModal();
    changeStatusPayment(
      item.xeroInvoiceID,
      EActionMethod.REJECTED,
      reasonValue || otherReasonValue
    );
  }, [closeModal, changeStatusPayment, item, reasonValue, otherReasonValue]);

  return (
    <div className="w-full p-6">
      <Title as="h6" className="@xl:basis-auto text-xl">
        Please enter reason:
      </Title>
      <Select
        placeholder="Please select reason..."
        size="sm"
        options={reasonOptions}
        value={reasonValue}
        variant="outline"
        onChange={setReasonValue}
        getOptionValue={(option) => option.value}
        displayValue={(selected) =>
          reasonOptions.find((option) => option.value === selected)?.label ?? ""
        }
        className={cn("capitalize w-full h-[38px], mt-4")}
      />
      <p className="mt-4">Other:</p>
      <Textarea
        size="sm"
        placeholder="Please enter reason..."
        onChange={onChangeOther}
      />
      <div className="w-full flex flex-row justify-end mt-4">
        <Button
          type="submit"
          disabled={isEmpty(otherReasonValue || reasonValue)}
          onClick={onSubmitReject}
        >
          Reject
        </Button>
      </div>
    </div>
  );
}
